export const FETCH_PACKAGE_DELIVERY_RANGES_PENDING = "FETCH_PACKAGE_DELIVERY_RANGES_PENDING";
export const FETCH_PACKAGE_DELIVERY_RANGES_REJECTED = "FETCH_PACKAGE_DELIVERY_RANGES_REJECTED";
export const FETCH_PACKAGE_DELIVERY_RANGES_FULFILLED = "FETCH_PACKAGE_DELIVERY_RANGES_FULFILLED";
export const CLEAR_PACKAGE_DELIVERY_RANGES = "CLEAR_PACKAGE_DELIVERY_RANGES";



// WEBPACK FOOTER //
// ./src/constants/packageDeliveryRanges.js